import React, { useRef } from 'react';
import {
    LayoutChangeEvent,
    NativeSyntheticEvent,
    StyleProp,
    TextInputChangeEventData,
    TextInputContentSizeChangeEventData,
    TextInputProps,
    TextStyle,
    View,
} from 'react-native';
import { TextInput } from 'react-native';
import InputBase, { innerTextInputStyles } from './InputBase';

export type InputOwnProps = {
    title: string;
    error?: string;
    value: string | null;
    onChange: (e: NativeSyntheticEvent<TextInputChangeEventData>) => void;
    onBlur?: TextInputProps['onBlur'];
    onFocus?: () => void;
    isDisabled?: boolean;
    testID?: string;
    multiline?: boolean;
    onLayout?: (event: LayoutChangeEvent) => void;
    secureTextEntry?: boolean;
    autoComplete?: TextInputProps['autoComplete'];
    RightAdornment?: React.ReactElement;
    forceFullWidth?: boolean;
    autoCapitalize?: TextInputProps['autoCapitalize'];
    numberOfLines?: number;
    textInputStyle?: StyleProp<TextStyle>;
    onContentSizeChange?: (e: NativeSyntheticEvent<TextInputContentSizeChangeEventData>) => void;
    placeholder?: string;
    isRequired?: boolean;
};

export type InputProps = InputOwnProps;

const Input: React.FC<InputProps> = (props) => {
    const inputRef = useRef<React.LegacyRef<TextInput> | null>(null);

    return (
        <InputBase
            {...props}
            disableRootPressableOnBlur
            onInputPress={() => {
                (inputRef.current as any)?.focus?.();
            }}
            renderInputField={({ onFocus, onBlur }) => (
                <View style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                    <TextInput
                        {...props}
                        ref={inputRef as any}
                        style={[innerTextInputStyles, props.textInputStyle]}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        value={props.value || ''}
                        multiline={props.multiline}
                        numberOfLines={props.numberOfLines || 1}
                        onLayout={props.onLayout}
                        secureTextEntry={props.secureTextEntry}
                        autoCorrect={!props.secureTextEntry}
                        autoComplete={props.autoComplete}
                        autoCapitalize={props.autoCapitalize}
                        placeholder={props.placeholder}
                    />
                    {props.RightAdornment ? props.RightAdornment : null}
                </View>
            )}
        />
    );
};

export default React.memo(Input);
